import { MfeConfig } from '@carvana/microfrontend';
import { AnalyticsPlugin } from '@carvana/microfrontend-plugins';
import { MfeReact, MfeReactComponent } from '@carvana/microfrontend-react';
import { useEffect } from 'react';
import { environment, isLocalEnvironment } from '~/constants/environment';

export const getMfeCacheBuster = () => {
  const date = new Date();
  const nearestQuarterHour = Math.round(date.getMinutes() / 15) * 15;

  return `${date.getDate()}-${date.getHours()}-${nearestQuarterHour}`;
};

function mfeConfigLoad(enableDebug: boolean) {
  return MfeConfig(
    {
      name: 'merch-ui',
      debug: enableDebug,
      Render: MfeReact(),
      ENV: isLocalEnvironment ? 'local' : environment,
      globals: {
        '@carvana/eventable-clickstream': () =>
          import('@carvana/eventable-clickstream'),
        '@carvana/eventable-web-vitals': () =>
          import('@carvana/eventable-web-vitals'),
        '@carvana/experiment': () => import('@carvana/experiment'),
        axios: () => import('axios'),
        // Axios/datadog/ReactRouterDom/StyledComponents (exact casing) are required by
        // AppraisalMFE (Carvana.STC.Appraisal.UI) -- confirmed with STC directly.
        Axios: () => import('axios'),
        datadog: () => import('@datadog/browser-rum'),
        React: () => import('react'),
        react: () => import('react'),
        ReactDOM: () => import('react-dom'),
        reactDom: () => import('react-dom'),
        'react-dom': () => import('react-dom'),
        ReactDOMClient: () => import('react-dom/client'),
        ReactRouterDom: () => import('react-router-dom'),
        JSXRuntime: () => import('react/jsx-runtime'),
        styled: () => import('styled-components'),
        'styled-components': () => import('styled-components'),
        PropTypes: () => import('prop-types'),
        propTypes: () => import('prop-types'),
        'prop-types': () => import('prop-types'),
        uuid: () => import('uuid'),
        vdpaxios: () => import('~/clients/axios'),
        authhttp: () => import('~/clients/httpWithAuth')
      },
      skipGlobalSSRLegacy: true,
      files: []
    },
    {
      plugins: [AnalyticsPlugin({ repository: 'Merch-UI' })]
    }
  );
}

export default function useMicroFrontend(enableDebug: boolean) {
  useEffect(() => {
    void mfeConfigLoad(enableDebug);
  }, [enableDebug]);
}

export function MfeComponent<OwnProps>(
  props: OwnProps & React.ComponentProps<typeof MfeReactComponent>
) {
  return <MfeReactComponent {...props} />;
}
